import { render, staticRenderFns } from "./PolicyHeader.vue?vue&type=template&id=ce3a03b8&scoped=true&"
import script from "./PolicyHeader.vue?vue&type=script&lang=js&"
export * from "./PolicyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3a03b8",
  null
  
)

export default component.exports